module.exports = __webpack_public_path__ + "img/southwire-logo.33948682.jpg";